import styled from "styled-components";
import { SwapBenifitTag, SwapTop } from "../Swap/styled";
import coin_header from "../../../assets/Dashboard/Swap/coin_header.png";
import { ButtonCommon } from "../../../Layout/styled";

export const LeaderboardContainer = styled.div`
  padding-bottom: 50px;
  @media screen and (max-width: 768px) {
    padding-bottom: 100px;
  }
`;
export const LeaderboardWrapper = styled.div`
  max-width: 1114px;
  margin: 0 auto;
  padding: 0 20px;
  @media screen and (max-width: 768px) {
    padding: 0 15px;
    width: unset;
  }
`;
export const LeaderboardDaily = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 12px;
  border: 1px solid #ff3556;
  background: linear-gradient(
    90deg,
    rgba(255, 53, 86, 0.1) 0%,
    rgba(255, 174, 200, 0.1) 100%
  );
  padding: 16px;
  margin-bottom: 32px;
  .daily-left {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
    p {
      font-family: Dirtyline;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px; /* 100% */
      text-transform: lowercase;
      background: linear-gradient(
        90deg,
        #ff3556 0%,
        #ff63a1 25%,
        #ffdb87 50%,
        #fff 100%
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .daily-right {
    width: 126px;
  }
  ${ButtonCommon} {
    font-size: 12px;
    font-weight: 500;
  }
  &.light {
    border: 1px solid #ff3556;
    background: linear-gradient(
      90deg,
      rgba(255, 53, 86, 0.2) 0%,
      rgba(255, 99, 161, 0.2) 50%,
      rgba(255, 219, 135, 0.2) 100%
    );
    .daily-left {
      p {
        background: linear-gradient(
          90deg,
          #ff3556 100%,
          #ff63a1 40.32%,
          #ffdb87 100%
        );
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }
  @media screen and (max-width: 768px) {
    display: block;
    .daily-left {
      margin-bottom: 12px;
    }
  }
`;
export const LeaderboardBanner = styled.div`
  background: url("/assets/images/leaderboard/leaderboard_banner.png") center /
    100% auto no-repeat;
  padding: 45px 16px;
  margin-bottom: 80px;
  .title-banner {
    color: #fff;
    font-family: Dirtyline;
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 96%; /* 30.72px */
    text-transform: lowercase;
    margin-bottom: 8px;
  }
  .des-banner {
    color: var(--Neutral-400, #92929e);
    font-family: Syne;
    font-size: 15.4px;
    font-style: normal;
    font-weight: 400;
    line-height: 19.2px; /* 124.675% */
    margin-bottom: 22px;
  }
  ${ButtonCommon} {
    width: 126px;
    font-size: 12px;
    font-weight: 500;
  }
  &.light {
    background: #fff;
    border: solid 1px rgb(184, 184, 193);
    border-radius: 12px;
    .title-banner,
    .des-banner {
      color: #000;
    }
  }
  @media screen and (max-width: 768px) {
    opacity: 0.83;
    background: linear-gradient(161deg, rgba(0, 0, 0, 0) 77.17%, #000 89.45%),
      radial-gradient(
        60.68% 64.55% at 76.29% 43.57%,
        rgba(7, 7, 7, 0) 0%,
        #070707 100%
      );
    border-radius: 12px;
    .title-banner {
      font-size: 22px;
    }
  }
`;
export const Campaigns = styled.div`
  margin-bottom: 80px;
  .swiper {
    padding-bottom: 40px;
    margin-top: -50px;
    padding-top: 50px;
  }
  .swiper-pagination-bullet {
    background: var(--Neutral-800, #43424a);
    opacity: 1;
  }
  .swiper-pagination-bullet-active {
    background: var(--trionn-com-cerise-red, #e0365c);
  }
  .swiper-button-next,
  .swiper-button-prev {
    width: 36px;
    height: 36px;
    border-radius: 4px;
    border: 1px solid var(--Neutral-700, #4d4d57);
    background: #1c1c1e;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.26s ease;
    &:after {
      background: url("/assets/images/leaderboard/icn_arrow_left.png") center /
        contain no-repeat;
      position: absolute;
      content: "";
      top: 50%;
      left: 50%;
      width: 20px;
      height: 20px;
      margin-top: -10px;
      margin-left: -10px;
    }
    &:hover {
      opacity: 0.7;
    }
  }
  .swiper-button-next {
    top: 24px;
    &:after {
      transform: scale(-1);
    }
  }
  .swiper-button-prev {
    right: 60px;
    left: unset;
    top: 24px;
  }
  .image-camp {
    width: 100%;
    height: 225px;
    object-fit: cover;
  }
  .title-campaign {
    color: #fff;
    font-family: Dirtyline;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 96%; /* 23.04px */
    text-transform: lowercase;
    margin-bottom: 20px;
  }
  .item-campaign {
    border-radius: 12px;
    border: 1px solid var(--Neutral-700, #4d4d57);
    background: #1c1c1e;
    backdrop-filter: blur(32.20338821411133px);
    padding: 16px 14px;
  }
  .image-camp {
    margin-bottom: 10px;
  }
  .block-title-campaign {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;

    h3 {
      overflow: hidden;
      color: #fff;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-family: Dirtyline;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 28px; /* 116.667% */
      text-transform: lowercase;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 70%;
    }
    p {
      font-family: Syne;
      font-size: 32px;
      font-style: normal;
      font-weight: 500;
      line-height: 56px; /* 175% */
      text-transform: capitalize;
      background: linear-gradient(
        90deg,
        #ff3556 25.28%,
        #ff63a1 50.82%,
        #ffd779 72.08%,
        #fff 100%
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 70%;
    }
  }
  .block-des {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
    p {
      color: var(--Neutral-400, #92929e);
      font-family: Syne;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 125%; /* 15px */
    }
    .list-social {
      display: flex;
      align-items: center;
      gap: 4px;
      li {
        border-radius: 4px;
        background: var(--Neutral-900, #3a3a40);
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &.light {
        li {
          background: #eeeef0;
        }
      }
    }
  }
  .block-join {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    .join-left {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .image-user {
      width: 24px;
      height: 24px;
      border-radius: 50%;
    }
    .host {
      display: block;
      color: var(--Neutral-400, #92929e);
      font-family: Syne;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 125%; /* 15px */
      margin-bottom: 2px;
    }
    .name-user {
      color: var(--Neutral-50, #f7f7f8);
      font-family: Syne;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 125%; /* 17.5px */
    }
    .join-right {
      display: flex;
      align-items: center;
      gap: 12px;
    }
    .list-user {
      display: flex;
      align-items: center;
      li {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        &:not(:first-child) {
          margin-left: -10px;
        }
      }
    }
    .number {
      display: block;
      color: var(--Neutral-50, #f7f7f8);
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 125%; /* 17.5px */
      margin-bottom: 2px;
    }
    .part {
      color: var(--Neutral-400, #92929e);
      font-family: Syne;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 125%; /* 15px */
    }
  }
  &.light {
    .title-campaign {
      color: var(--Red-950, #430c0c);
    }
    .item-campaign {
      background-color: #fff;
      border-color: rgb(184, 184, 193);
    }
    .block-title-campaign {
      h3 {
        color: var(--Neutral-950, #141518);
      }
      p {
        color: var(--Neutral-500, #6e6e7c);
      }
    }
    .block-des {
      p {
        color: #000;
      }
    }
    .user-info {
      span {
        color: #000;
      }
    }
    .block-join {
      .host {
        color: var(--Neutral-500, #6e6e7c);
      }
      .name-user {
        color: var(--Neutral-900, #3a3a40);
      }
      .number {
        color: var(--Neutral-900, #3a3a40);
      }
      .part {
        color: var(--Neutral-500, #6e6e7c);
      }
    }
    .swiper-button-next,
    .swiper-button-prev {
      border: 1px solid var(--Neutral-300, #b8b8c1);
      background: #fff;
      &:after {
        background-image: url("/assets/images/leaderboard/icn_arrow_left_black.png");
      }
    }
  }
  @media screen and (max-width: 768px) {
    margin-bottom: 40px;
    .image-camp {
      width: 100%;
      height: 200px;
    }
    .block-title-campaign {
      h3 {
        font-size: 20px;
        width: 60%;
      }
      .price {
        font-size: 24px;
      }
    }
  }
  .block-button {
    ${ButtonCommon} {
      width: 126px;
      margin-left: auto;
    }
    &.light {
      a {
        background: var(--Neutral-100, #eeeef0);
        color: #230b34;
      }
    }
  }
`;
//
export const LeaderboardTop = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 11px;
  ${SwapTop} {
    margin-bottom: 0;
    padding-right: 80px;
    &:before {
      right: 0;
      left: unset;
    }
  }
  ${SwapBenifitTag} {
    .item-tag {
      flex: unset;
      gap: unset;
      border-radius: 41px;
      padding: 8px 16px;
      display: flex;
      flex-direction: unset;
      align-items: center;
      justify-content: center;
      gap: 10px;
      font-size: 15px;
      span {
        display: inline-flex;
        width: 8px;
        height: 8px;
        border-radius: 50%;
      }
    }
  }
  @media (min-width: 768px) and (max-width: 850px) {
    display: block;
    ${SwapBenifitTag} {
      margin-bottom: 30px;
    }
  }
  @media screen and (max-width: 768px) {
    display: block;
    ${SwapTop} {
      margin-bottom: 30px;
      padding-right: 0;
      &::before {
        top: 50%;
        margin-top: -30px;
        background: url(${coin_header}) no-repeat center / 100% auto;
      }
    }
    ${SwapBenifitTag} {
      .item-tag {
        width: unset;
        font-size: 14px;
      }
    }
  }
`;
export const LeaderboardTotal = styled.ul`
  color: #fff;
  display: flex;
  align-items: center;
  border-radius: 12px;
  border: 1px solid var(--Neutral-800, #43424a);
  background: #1c1c1e;
  padding: 16px;
  margin-bottom: 0;
  li {
    text-align: center;
    position: relative;
    padding: 0 17px;
    &:not(:last-child) {
      &:after {
        position: absolute;
        content: "";
        top: 0;
        right: 0;
        bottom: 0;
        width: 1px;
        height: 100%;
        background: var(--Neutral-500, #6e6e7c);
      }
    }
    .text {
      color: var(--Neutral-400, #92929e);
      text-align: center;
      font-family: Syne;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px; /* 125% */
      margin-bottom: 5px;
    }
    .number {
      color: var(--Neutral-50, #f7f7f8);
      text-align: center;
      font-family: DMMono-500;
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px; /* 111.111% */
    }
  }
  &.light {
    background: #fff;
    border-color: rgb(184, 184, 193);
    li {
      background: #fff;
      border-color: rgb(184, 184, 193);
      .text {
        color: var(--Neutral-500, #6e6e7c);
      }
      .number {
        color: var(--Neutral-800, #43424a);
      }
    }
  }
  @media (min-width: 768px) and (max-width: 850px) {
    li {
      width: calc(100% / 3);
    }
  }
  @media screen and (max-width: 768px) {
    background: unset;
    border: 0;
    border-radius: 0;
    gap: 6px;
    align-items: unset;
    padding: 0;
    li {
      width: calc(100% / 3 - 6px);
      padding: 12px;
      border-radius: 10.12px;
      border: 1px solid #404040;
      background: #1c1c1e;
      overflow: hidden;
      &:before {
        position: absolute;
        content: "";
        background: url("/assets/images/leaderboard/icn_kibble.png") center /
          cover no-repeat;
        width: 90.11px;
        height: 90.11px;
        right: unset;
        left: 0;
        bottom: -4px;
        pointer-events: none;
      }
      &:not(:last-child) {
        &:after {
          content: none;
        }
      }
      .text {
        font-size: 11px;
        text-align: left;
        font-family: unset;
      }
      .number {
        font-size: 22px;
        text-align: right;
      }
    }
  }
`;

export const LeaderboardBottom = styled.div`
  table {
    background: #1c1c1e;
  }
  .ant-table-thead {
    tr {
      background: #2c2c2c;
    }
    .ant-table-cell {
      color: var(--Neutral-400, #92929e);
      text-align: center;
      font-family: Syne;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      padding: 15px 10px;
    }
  }
  .ant-table-tbody {
    background: #1c1c1e;
    .ant-table-cell {
      padding: 17px 0;
      font-family: DMMono-400;
      color: var(--Neutral-50, #f7f7f8);
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 125% */
      letter-spacing: -0.96px;
    }
  }
  @media screen and (max-width: 768px) {
    table {
      border: 0;
      padding: 6px;
      overflow: hidden;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
    .ant-table-tbody {
      .ant-table-cell {
        border-radius: 10px;
        border: 0.778px solid #323232;
        background: #18191c;
        padding: 6px !important;
        overflow: hidden;
      }
      .ant-table-row {
        &:not(:last-child) {
          margin-bottom: 6px;
        }
      }
    }
  }
`;
export const BlockAddress = styled.div`
  .copy-inner {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    &.light {
      p {
        color: #000;
      }
    }
  }
  p {
    color: var(--Neutral-200, #d9d9de);
    text-align: center;
    font-family: DMMono-400;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: -0.96px;
  }
  a {
    p {
      transition: all .2s linear;
    }
    &:hover p {
      color: #1ce8ef;
    }
  }
  img {
    cursor: pointer;
  }
`;

export const ContentTableMobile = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  .rank {
    border-radius: 7px;
    background: rgba(255, 255, 255, 0.25);
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--Red-100, #fde3e3);
    text-align: center;
    font-size: 32px;
    line-height: 100%; /* 32px */
    font-family: DMMono-500;
  }
  .content-right {
    width: calc(100% - 66px);
  }
  .block-address {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
  }
  .address {
    color: var(--Red-100, #fde3e3);
    font-size: 16px;
    font-weight: 700;
    line-height: 16px; /* 100% */
    text-transform: lowercase;
  }
  .block-transactions {
    display: flex;
    gap: 4px;
  }
  .transaction-inner {
    width: calc(100% / 2 - 17px);
    border-radius: 4px;
    background: #2c2c2c;
    padding: 6px 8px;
    p {
      color: #868686;
      text-align: center;
      font-size: 11px;
      font-weight: 500;
      line-height: 150%; /* 16.5px */
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        color: var(--Neutral-50, #f7f7f8);
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-family: DMMono-500;
        line-height: 150%; /* 18px */
      }
    }
  }
  .copy {
    width: 20px;
    height: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
    img {
      width: 20px;
      height: 21px;
      border-radius: 0;
    }
  }
  &.light {
    .copy-inner {
      p {
        color: #000;
      }
      svg {
        fill: #000;
      }
    }
    .transaction-inner {
      background-color: #fff;
      border: solid 1px rgb(184, 184, 193);
      p,
      span {
        color: #000;
      }
    }
    .address {
      color: #000;
    }
  }
  @media screen and (max-width: 768px) {
    .block-transactions {
      &:not(:last-child) {
        margin-bottom: 6px;
      }
    }
  }
`;

export const YourRank = styled.div`
  background: #3b3b3b;
  padding: 12px 8px;
  border-top-left-radius: 17px;
  border-top-right-radius: 17px;
  .rank {
    font-size: 15px;
  }
  .transaction-inner {
    background: rgba(255, 255, 255, 0.84);
    p {
      color: #868686;
      span {
        color: var(--Neutral-900, #3a3a40);
      }
    }
  }
`;
